/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { memo, useEffect } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import {
  abortPreviousRequestsIfAny,
  getAnalysisUrlKey,
  getImageUrlKey,
} from "@/abort";
import { PreloaderScreen } from "@/components";
import { useRedirect } from "@/hooks/useRedirect";
import { PageWithHardStopProps } from "@/types/SolarFormProps";

import { ratProcessing } from "./content.json";
import { useRATProcessing } from "./useRATProcessing";

type RATProcessingProps = Omit<PageWithHardStopProps, "backRoute"> & {
  degradedNextRoute: () => Promise<string>;
  delay: number;
};

export const RATProcessing = memo(
  ({
    delay,
    nextRoute,
    hardStopRoute,
    degradedNextRoute,
  }: RATProcessingProps) => {
    const { setValue, getValues } = useFormContext();
    const watchedCanService = useWatch({ name: "canService" });

    const { analyzeRoof } = useRATProcessing();
    const { goNextRoute } = useRedirect();

    const doNavigate = async (canService?: boolean) => {
      if (canService === undefined) {
        return;
      }

      const gotoRoute = getValues("degradedExperience")
        ? degradedNextRoute
        : nextRoute;

      let to: string;
      if (canService) {
        to = await gotoRoute();
      } else {
        setValue("hardStop", "RATProcessing");
        to = await hardStopRoute();
      }

      goNextRoute(to);
    };

    useEffect(() => {
      setValue("canService", undefined);
      analyzeRoof();

      return () =>
        abortPreviousRequestsIfAny(getImageUrlKey(), getAnalysisUrlKey());
    }, [analyzeRoof]);

    useEffect(() => {
      const timeoutId = setTimeout(() => {
        doNavigate(watchedCanService);
      }, delay);

      return () => clearTimeout(timeoutId);
    }, [watchedCanService]);

    return (
      <PreloaderScreen
        id={ratProcessing.id}
        heading={ratProcessing.heading}
        description={ratProcessing.description}
      />
    );
  }
);
